import { render, staticRenderFns } from "./switchTemplateOneDialog.vue?vue&type=template&id=adaf2476&"
import script from "./switchTemplateOneDialog.vue?vue&type=script&lang=js&"
export * from "./switchTemplateOneDialog.vue?vue&type=script&lang=js&"
import style0 from "./switchTemplateOneDialog.vue?vue&type=style&index=0&id=adaf2476&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports